<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="title-h3">IP 사용 현황</div>
      <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote ref="ipTable"
      :data="tableData" :columns="tableColumn" :pagination="true" :show-search-tool="showSearchTool" style="width:100%;" :show-custom-header="true">
      <template slot-scope="scope" slot="using-persent">
        <el-progress :text-inside="true" :stroke-width="40" :percentage="scope.row.usingPersent" color="#00B0F0"></el-progress>
      </template>
      <template slot-scope="scope" slot="ipaddress-slot">
        <a href="#" class="ipaddress-col" style="color: #1c53ca; " @click="onClickIpaddress(scope.row)">{{ scope.row.ip }}</a>
      </template>
    </el-table-wrapper>
    <w-ip-usage-sliding-popup ref="ipUsageSlidingPopup"></w-ip-usage-sliding-popup>
  </div>
</w-settings-content-template>
</template>

<script>
import { columnDefault } from '@/constants/table';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { isNil, cloneDeep } from 'lodash';
import NetdeviceIpManagement from '@/api/settings/netdevice/netdevice-ip-management';
import WIpUsageSlidingPopup from './popup/IpUsageSlidingPopup';

export default {
  name: 'WIpUsageStatusList',
  components: {
    WSettingsContentTemplate,
    NetdeviceIpManagement,
    WIpUsageSlidingPopup,
  },
  data() {
    return {
      total: null,
      columnDefault,
      showSearchTool: false,
      tableData: [],
      tableColumn: [
        {
          prop: 'ip',
          label: 'IP 주소',
          width: 150,
          scopedSlot: 'ipaddress-slot',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'subnet',
          label: '서브넷 마스크',
          width: 150,
          sortable: true,
          searchable: true,
        },
        {
          prop: 'dhcpRange',
          label: 'IP 구간',
        },
        {
          prop: 'purpose',
          label: '용도',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'addressTypeName',
          label: '구분',
          width: 70,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'usingPersent',
          label: 'IP 사용률',
          scopedSlot: 'using-persent',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'issueDate',
          label: '확인시각',
          formatter: this.getDateFormatter,
          searchable: true,
          searchType: 'date',
          sortable: true,
          width: 160,
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.ipTable.getParameter();
      const params = {
        ...tableParams,
      };
      NetdeviceIpManagement.getIpUseList(params).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onChangeTable() {
      this.loadData();
    },
    onClickIpaddress(row) {
      this.$refs.ipUsageSlidingPopup.open(cloneDeep(row));
    },
  },
};
</script>

<style scoped>
.ipaddress-col:hover {
  text-decoration-line: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/IpManagementSettings/IpUsageStatusList/index.vue